<template>
    <div class="detail clearfix" style="padding-bottom:24px">
        <div class="protect">
            <p>常见问题</p>
            <div class="line left"></div>
            <div class="line right"></div>
        </div>
        <div v-for="(item,index) in obj" v-if="type==1">
            <div class="qa-item">
                <p>{{item.question}}</p>
                <div class="icon" :class="{icon2:item.isopened}" @click="toggle(index)"></div>
            </div>
            <div class="qa-content" v-show="item.isopened">
                {{item.anwser}}
            </div>
            <div class="qa-line" v-if="index != 4 && !item.isopened"></div>
        </div>
        <div v-for="(item,index) in obj2" v-if="type==2">
            <div class="qa-item">
                <p>{{item.question}}</p>
                <div class="icon" :class="{icon2:item.isopened}" @click="toggle(index)"></div>
            </div>
            <div class="qa-content" v-show="item.isopened">
                {{item.anwser}}
            </div>
            <div class="qa-line" v-if="index != 2 && !item.isopened"></div>
        </div>
        <div v-for="(item,index) in obj3" v-if="type==3">
            <div class="qa-item">
                <p>{{item.question}}</p>
                <div class="icon" :class="{icon2:item.isopened}" @click="toggle(index)"></div>
            </div>
            <div class="qa-content" v-show="item.isopened">
                {{item.anwser}}
            </div>
            <div class="qa-line" v-if="index != 1 && !item.isopened"></div>
        </div>
        <template v-if="type==4" >
          <div v-for="(item,index) in obj4" :key="index">
            <div class="qa-item">
                <p>{{item.question}}</p>
                <div class="icon" :class="{icon2:item.isopened}" @click="toggle(index)"></div>
            </div>
            <div class="qa-content" v-show="item.isopened">
              <span>{{item.anwser}}</span><span style="color: #0285f0" @click="handle(item)">{{item.event}}</span>
            </div>
            <div class="qa-line" v-if="index != 1 && !item.isopened"></div>
        </div>
        </template>
        <template v-if="type==5">
          <div v-for="(item,index) in obj5" :key="index">
            <div class="qa-item">
                <p>{{item.question}}</p>
                <div class="icon" :class="{icon2:item.isopened}" @click="toggle(index)"></div>
            </div>
            <div class="qa-content" v-show="item.isopened">
                {{item.anwser}}
            </div>
            <div class="qa-line" v-if="index != 1 && !item.isopened"></div>
        </div>
        </template>
    </div>
</template>

<script>  
export default {
  name: 'qa',
  props:['type'],
  data () {
    return {
        obj:[{
                question:'保险会收取费用吗？',
                anwser:'WiFi安全险是完全免费的。是为了WiFi万能钥匙用户的上网安全提供的一份专属免费保障。',
                isopened:false
            },{
                question:'什么WiFi安全险？',
                anwser:'WiFi安全险包含用户安全险和热点商户联盟安全险。WiFi万能钥匙用户因使用WiFi万能钥匙连接了恶意热点而导致本人银行账户及合法的第三方支付机构实名账户中的资金遭受直接损失，用户可按照WiFi万能钥匙保险计划的有关规则申请索赔。商户通过WiFi万能钥匙分享WiFi后，因黑客篡改WiFi密码、劫持商户收银、盗刷商户账户内资金等恶意行为导致商户产生损失的，商户可以依据本保险计划的有关规则申请理赔。',
                isopened:false
            },{
                question:'如何参保？',
                anwser:'点击底部［免费参保］按钮，完成简单的信息填写即可成功投保。',
                isopened:false
            },{
                question:'保险是哪家公司发行的？',
                anwser:'WiFi安全险由WiFi万能钥匙联合众安保险推行。众安在线财产保险股份有限公司（港交所：6060）简称众安保险，是全国名列前茅的联网保险公司。',
                isopened:false
            },{
                question:'最高能赔多少钱？',
                anwser:'每人年度累计最高可以赔付10万元，单日/单次最高可以赔付2万元。',
                isopened:false
            }],
        obj2:[{
                question:'如何申请理赔？',
                anwser:'用户完成参保后使用WiFi万能钥匙连接网络发生了WiFi安全险保障范围内的情形，打开WiFi万能钥匙，进入WiFi安全险页面，点击申请理赔。',
                isopened:false
            },{
                question:'申请理赔需要注意些什么？',
                anwser:'使用WiFi万能钥匙连接网络遭受损失后，应立即采取相关证据保全措施，不应自行刷机、清理手机垃圾、删除WiFi万能钥匙客户端、历史短信或历史访问网址记录，或自行删除交易过程中与交易对方的聊天记录及所下载的软件，以免导致相关证据无法保全。',
                isopened:false
            },{
                question:'WiFi安全险保障的范围是什么？',
                anwser:'通过WiFi万能钥匙连接的热点网络环境下发生了WiFi热点恶意行为，导致用户本人在银行账户内的资产，以及在合法运营的第三方支付机构所设本人实名账户中的资产遭受直接损失。',
                isopened:false
            }],
        obj3:[{
                question:'为什么要填写我的信息？',
                anwser:'WiFi安全险是一款保险产品，投保时需要您提供准确的信息，以便获得后续的保险服务。',
                isopened:false
            },{
                question:'我的信息会泄漏吗？',
                anwser:'不会。您填写的信息仅用于WiFi安全险的参保和申请理赔时确认身份用途，并不会用于其他商业用途',
                isopened:false
            },{
                question:'提示身份证号码已占用，怎么办？',
                anwser:'如身份证号码曾提交过参保信息，绑定的手机号码已停用，请联系官方客服电话:4000358000，同时提供身份证正反面以及手持身份证的上半身照片，由官方客服进行处理。',
                isopened:false
            }],
        obj4:[{
            question:'为什么要填写并提交商户信息？',
            anwser:'WiFi万能钥匙和众安保险达成合作，将为每个商户提供免费WiFi安全险，如商户因分享WiFi而产生财产非正常损失，可向众安保险提出理赔申请，最高可获10万元保险理赔金。您所提交的商户信息仅用于投保使用。',
            isopened:false
        },{
            question:'我的信息会泄露吗？',
            anwser:'不会。您填写的信息仅用于WiFi安全险的参保和申请理赔时确认身份用途，并不会用于其他商业用途。',
            isopened:false
        },{
            question:'如何确认WiFi已被分享？',
            anwser:'WiFi万能钥匙商户热点安全险仅针对在WiFi万能钥匙内已分享的热点，需要您提交准确的热点名称和Mac地址，才能参保。请在WiFi万能钥匙App连接列表，确认WiFi已分享，即WiFi带有蓝色小钥匙；如未显示，请先分享此热点。需输入的热点名称，是在WiFi万能钥匙内显示的名称，请注意字母大小写、符号。',
            event: '（点击此处查看操作图示）',
            path: '/new/isShare',
            isopened:false
        },{
            question:'如何查看MAC地址？',
            anwser:'路由器背面的铭牌上有明确标注“MAC”。MAC长度是12位，由0-9之间的数字和a-f之间的字母组成。填写的时候只需要填写字母和数字部分，不需要填写“:”，“-”。',
            event: '（点击此处查看操作图示）',
            path: '/new/findMac',
            isopened:false
        },{
            question:'更换路由器、热点名称怎么办？',
            anwser:'WiFi万能钥匙会在保险有效期内，保护参保商户基于提交的已分享的热点信息进行权益保护，一旦路由器更换，或热点名称修改，请联系官方客服电话:4000358000，同时提供身份证正反面以及手持身份证的上半身照片，新的Mac地址或热点信息，由官方客服进行处理。',
            isopened:false
        },{
            question:'提示身份证号码已占用，怎么办？',
            anwser:'如身份证号码曾提交过参保信息，绑定的手机号码已停用，请联系官方客服电话:4000358000，同时提供身份证正反面以及手持身份证的上半身照片，由官方客服进行处理。',
            isopened:false
        },{
            question:'提示热点被他人投保，怎么办？',
            anwser:'WiFi万能钥匙商户热点安全险参保人必须是商户赖以执行参保的设备持有者，如提示热点被他人参保占用，请联系官方客服电话:4000358000，根据要求提供热点证明相关资料，由官方客服进行处理。',
            isopened:false
        }],
        obj5:[{
              question:'如何申请理赔？',
              anwser:'商户完成参保，通过WiFi万能钥匙分享WiFi后，发生了因黑客篡改WiFi密码、劫持商户收银、盗刷商户账户内资金等恶意行为导致商户产生损失的情形，打开WiFi万能钥匙，进入WiFi安全险页面，点击申请理赔。',
              isopened:false
          },{
              question:'申请理赔需要注意些什么？',
              anwser:'商户在使用WiFi万能钥匙分享热点后，发现账户资金遭受损失的，应立即采取相关证据保全措施，不应自行刷机、清理交易设备缓存、删除WiFi万能钥匙客户端、历史短信或历史访问网址记录，或自行删除交易过程中与交易对方的聊天记录及所下载的软件，以免导致相关证据无法保全。',
              isopened:false
          },{
              question:'WiFi商户热点安全险保障的范围是什么？',
              anwser:'商户通过WiFi万能钥匙分享WiFi后，因黑客篡改WiFi密码、劫持商户收银、盗刷商户账户内资金等恶意行为，导致商户在银行账户内的资产，及商户在合法运营的第三方支付机构所设本商户实名账户中的资产遭受直接损失。',
              isopened:false
          }],
    }
  },
    methods:{
        toggle(index){
            if(this.type == 1) this.obj[index].isopened = !this.obj[index].isopened
            if(this.type == 2) this.obj2[index].isopened = !this.obj2[index].isopened
            if(this.type == 3) this.obj3[index].isopened = !this.obj3[index].isopened
            if(this.type == 4) this.obj4[index].isopened = !this.obj4[index].isopened
            if(this.type == 5) this.obj5[index].isopened = !this.obj5[index].isopened
        },
        handle(val) {
          this.$router.push(val)
        }
    }
}
</script>

<style scoped>

    .protect{
        position: relative;
        text-align: center;
    }
    .protect p{
        font-size: 16px;
        line-height: 60px;
        color: #000;
        font-weight: 600;
    }
    .protect .line{
        position: absolute;
        top:29px;
        width: 34.66%;
        height:1px;
        background: #E8E8E8;
    }
    .protect .left{
        left:-1%;
    }
    .protect .right{
        right:-1%;
    }
    .detail .qa-item{
        position: relative;
        margin: 0 12px;
    }
    .qa-item p{
        padding: 0;
        margin: 0;
        color: #797979;
        font-size: 14px;
        line-height: 40px;
        text-align: left;
        width: 100%;
    }
    .qa-item .icon{
        position: absolute;
        top:30px;
        right:0;
        width: 100%;
        padding-top: 2.9%;
        background: url(../images/index/zhankai.png) no-repeat right;
        background-size: contain;
        transform:translateY(-150%);
    }
    .qa-item .icon2{
        position: absolute;
        top:30px;
        right:0;
        width: 100%;
        padding-top: 2.9%;
        background: url(../images/index/zhedie.png) no-repeat right;
        background-size: contain;
        transform:translateY(-150%);
    }
    .detail .qa-line{
        margin: 0 12px;
        height:0.9px;
        background: #EFEFEF;
    }
    .qa-content{
        background: #FBFBFB;
        margin: 0 12px;
        border: 1px solid #EEEEEE;
        border-radius: 6px;
        padding: 10px 15px;
        font-size: 14px;
        line-height: 26px;
    }

    .detail span, .detail a  {
      float: none;
    }
    
</style>



// WEBPACK FOOTER //
// qa.vue?355127c5